import {Component, Inject, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {UserService} from '../../../../services/users-service/user-service';
import {ErrorService} from '../../../../util/error_service/error.service';
import {MD_DIALOG_DATA, MdDialog, MdDialogRef} from "@angular/material";
import {ToastService} from "../../../../util/toast-service/toast.service";

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss']
})
export class WalletComponent implements OnInit {

  errorResponse: any;
  pageTitle = 'Wallet Transactions';
  public adminsTotal: number;
  public admins : any;
  public airtimeTransactions : any;
  public isTransactionsLoaded : boolean;
  public transactionsWithId : any;
  public range: any;
  public useRange: boolean;
  public rangeFromValue: number;
  public fromDate: Date;
  public toDate: Date;
  public rangeToValue: number;
  public arg: any;
  public recentTransaction = [];
  public searchText = '';

  public checkboxArgs : any;

  public isSuccessTicked : boolean;
  // public isPendingTicked : boolean;
  public isFailedTicked : boolean;

  public dashboardData : any = {
    'failedTrans': 0,
    'pendingTrans': 0,
    'successfulTran': 0,
    'transactionCount': 0
  }


  constructor(public _sharedService: SharedService, public toast: ToastService, public dialog: MdDialog, public adminService: UserService, public error: ErrorService) {
    this._sharedService.emitChange(this.pageTitle);
    this.adminsTotal = 0;
    this.range = 'today'; // default range is today
    this.isTransactionsLoaded = true;
    this.transactionsWithId = [];
    this.admins = [];
    this.checkboxArgs = [];
    this.isSuccessTicked = true;
    // this.isPendingTicked = true;
    this.isFailedTicked = true;
    this.getRange();
    this.getWalletStatistics();
    this.getWalletTransactions();

  }

  // Re-Sort data ////////////////////
  getTransactionsWithId() {
    this.transactionsWithId = [];
    for (let i = 0; i < this.airtimeTransactions.length; i++ ) {
      const sortedTranx: any = {id: 0, data: {}};
      sortedTranx.id = i + 1;
      sortedTranx.data = this.airtimeTransactions[i];
      this.transactionsWithId.push(sortedTranx);
      this.isTransactionsLoaded = false;
    }
    // console.log('************ trax with id ****************');
    // console.log(this.transactionsWithId);
  }

  // populate transactions statistics
  getWalletStatistics = () => {
    this.adminService.getStatistics().subscribe(
      response => {
        const statisticsData = response.data[0];
        // console.log(statisticsData);
        this.dashboardData.transactionCount = statisticsData.walletTrans;
        // this.dashboardData.successfulTran = statisticsData.todaySuccessfulWalletTransactions;
        // this.dashboardData.pendingTrans = statisticsData.todayPendingWalletTransactions;
        // this.dashboardData.failedTrans = statisticsData.todayFailedWalletTransactions;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getWalletStatistics, err);
        // console.log(this.errorResponse);

      }
    )
  }

  // get all airtime transactions or by range
  getWalletTransactions = () => {
    this.airtimeTransactions = [];
    this.isTransactionsLoaded = true;
    this.adminService.getWalletTransactionsByPeriod(this.arg).subscribe(
      response => {
        this.airtimeTransactions = response.data;
        // console.log('***** Wallet Transactions ****');
        // console.log(this.airtimeTransactions);
        this.getTransactionsWithId();
        // console.log('***** Wallet Transactions with id ****');
        // console.log(this.transactionsWithId);
        this.isTransactionsLoaded = false;
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getWalletStatistics, err);
        // console.log(this.errorResponse);
        this.isTransactionsLoaded = false;

      }
    )
  }

  // get transactions by range
  getRangeTransaction() {
    this.rangeFromValue = new Date(this.fromDate).getTime();
    this.rangeToValue = new Date(this.toDate).getTime();
    this.arg = 'range?startDateTimestamp=' + this.rangeFromValue + '&' + 'endDateTimestamp=' + this.rangeToValue;
    this.recentTransaction = [];
    this.getWalletTransactions();
  }

  getRange = () => {
    if ( this.range !== 'other') {
      this.useRange = false;
      this.arg = this.range;
      this.recentTransaction = [];
      this.getWalletTransactions();
    } else {
      this.useRange = true;
    }
  }

  getAdminName = (id : any) => {
    // console.log("Adimin id = "+id);
    let mAdmin = this.admins.filter(admin => id == admin.id)[0];
    if(mAdmin){
      return mAdmin.firstName + ' '+mAdmin.lastName;
    }
    else{
      return 'deleted Admin';
    }
  }

  getAdmins = () => {
    this.adminService.getAdmins().subscribe(
      response => {
        // console.log('******* Admins *******');
        this.admins = response.data;
        this.getWalletTransactions();

        this.isTransactionsLoaded = false;
        // console.log(this.admins);
        // // console.log('******* Single Admin *******');
        // // console.log(this.admins[0].firstName);
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAdmins, err);
        // console.log(this.errorResponse);

      }
    )
  }


  ngOnInit() {
    this.getWalletStatistics();
    this.getAdmins();
  }
  downloadDialog() {
    const dialogRef = this.dialog.open(WalletReportDialogComponent,{
      height: '450px',
      width: '400px',
      data: {
        id : '3'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      // console.log('********', result);
      if( result == 'close'){
        return false;
      }
      else if( result == 'success'){
        const message = 'Report download was successful' ;
        this.toast.showSuccess(message, 'Download');
      }
      else if( result == 'failed'){
        const message = 'Report download failed' ;
        this.toast.showError(message, 'Download');
      }
    });
  }

}


@Component({
  selector: 'download-dialog',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'report-dialog.html',
})
export class WalletReportDialogComponent {
  isDownloading: boolean;
  download: number;
  isPendingTicked: boolean;
  isFailedTicked: boolean;
  isSuccessTicked: boolean;
  errorResponse: any;
  rangeToValue: number;
  fromDate: any;
  rangeFromValue: number;
  useRange: boolean;
  systemCommission: any;
  networkName: any;
  agentCommission: any;
  networkId: any;
  range : any;


  public amount : number;
  public isUpdating : boolean;
  public toDate: any;
  public arg: string;


  constructor(
    public dialogRef: MdDialogRef<WalletReportDialogComponent>, private agentService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any, public adminService: UserService,) {
    this.networkId = this.data.id;
    this.range = 'today';
    this.isSuccessTicked = true;
    this.isFailedTicked = true;
    this.isPendingTicked = true;
    this.download = 1;
    this.isDownloading = false;
    this.getRange();
  }

  getRange = () => {
    if ( this.range !== 'other') {
      this.useRange = false;
      this.arg = this.range+ '?';
    } else {
      this.useRange = true;
    }
  }

  getRangeTransaction = () => {
    this.rangeFromValue = new Date(this.fromDate).getTime();
    this.rangeToValue = new Date(this.toDate).getTime();
    this.arg = '/range?startDateTimestamp=' + this.rangeFromValue + '&' + 'endDateTimestamp=' + this.rangeToValue  + '&';
    // console.log('********* using range transaction', this.arg);
    //this.downloadReport();
  }

  // get all airtime transactions or by range
  downloadReport = () => {

    if(this.useRange){
      this.getRangeTransaction();
    }

    this.isDownloading = true;
    this.adminService.getWalletTransactionsByPeriod(this.arg, this.download, this.isSuccessTicked ? 1:0, this.isFailedTicked ? 1:0, this.isPendingTicked ? 1:0).subscribe(
      response => {

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.blob());
          return;
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.blob());
        // start download
        link.download= "wallet-report.csv";
        link.click();
        this.isDownloading = false;
        this.dialogRef.close('success');
      },
      err => {
        // // console.log(err);
        this.error.errorHandlerWithText(this.downloadReport, err);
        //this.dialogRef.close('failed');
        //this.isDownloading = false;
        // this.errorResponse = this.error.errorHandlerWithText(this.downloadReport, err);
        // // console.log(this.errorResponse);
      }
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/transactions/wallet/wallet.component.ts